const debug = process.env.NODE_ENV !== 'production'

import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

window.Vue.use(Vuex)

export default new Vuex.Store({
    modules: {

    },
    state: {
        quote: {},
        vehicles: [],
        people: [],
        customer: null,
        business_account: null,
        business_addresses: null,
        policy_start_date: null,
        available_services: [],
        hidden_excess: false,
        upgradeQuote: {},
        vehicles_removed: false,
    },
    getters: {
        quote(state) {
            return state.quote
        },
        vehicles(state) {
            return state.vehicles
        },
        people(state) {
            return state.people
        },
        customer(state) {
            return state.customer
        },
        policy_start_date(state) {
            return state.policy_start_date
        },
        available_services(state) {
            return state.available_services
        },
        hidden_excess(state) {
            return state.hidden_excess
        },
        upgradeQuote(state) {
            return state.upgradeQuote
        },
        business_account(state) {
            return state.business_account
        },
        business_addresses(state) {
            return state.business_addresses
        },
    },
    mutations: {
        SET_QUOTE(state, inputValue) {
            for (const [key, value] of Object.entries(inputValue)) {
              Vue.set(state.quote, key, value)
            }
        },
        ADD_VEHICLE(state, vehicle) {
            state.vehicles.push(vehicle)
            if(!state.quote){
                state.quote = {}
            }
            state.quote.no_vehicles = state.vehicles.length
        },
        SET_PEOPLE(state, people) {
            state.people = [...people];
            if (!state.quote) {
                state.quote = {};
            }
            state.quote.no_people = state.people.length + 1;
        },
        ADD_PEOPLE(state, people) {
            state.people = [...people];
            if (!state.quote) {
                state.quote = {};
            }
            state.quote.no_people = state.people.length + 1;
        },
        UPDATE_PEOPLE(state, { index, field, value }) {
            if (field === 'day' || field === 'month' || field === 'year') {
                state.people[index].dateOfBirth = {
                    ...state.people[index].dateOfBirth,
                    [field]: {
                        value: value
                    },
                }
            } else if(field === 'id') {
                state.people[index].id = value
            } else {
                state.people[index][field].value = value;
            }
        },
        INIT_PEOPLE_ARR(state, peopleArr) {
            state.quote.no_people = peopleArr.length + 1
            state.people = peopleArr
        },
        SET_VEHICLES(state,vehicles){
            state.vehicles = vehicles
            if(!state.quote){
                state.quote = {}
            }
            state.quote.no_vehicles = state.vehicles.length
        },
        RESET_VEHICLES(state){
            state.vehicles = []
            if(!state.quote){
                state.quote = {}
            }
            state.quote.no_vehicles = state.vehicles.length
        },
        RESET_PEOPLE(state){
            state.people = []
            if(!state.quote){
                state.quote = {}
            }
            state.quote.no_people = state.people.length
        },
        SET_QUOTE_ID(state,id){
            state.quote = {...state.quote, id: id}
        },
        RESET_ALL(state){
            state.quote = {}
            state.vehicles = []
            state.people = []
            state.customer = null
            state.policy_start_date = null
            state.hidden_excess = false
            state.business_account = null
            state.business_addresses = null
            state.vehicles_removed = false
        },
        REMOVE_VEHICLE(state, vehicle) {
            state.vehicles = state.vehicles.filter(item => {
                return item.vrm !== vehicle.vrm
            })
            if(!state.quote){
                state.quote = {}
            }
        },
        SET_CUSTOMER(state, customer) {
            state.customer = customer
        },
        SET_START_DATE(state,date){
            state.policy_start_date = date
        },
        SET_COUPON(state,couponObj){
            state.quote = {...state.quote, coupon: couponObj}
        },
        SET_AVAILABLE_SERVICES(state,services){
            state.available_services = services
        },
        RESET_QUOTE(state){
            state.quote = {}
        },
        SET_HIDDEN_EXCESS(state, isHidden)
        {
            state.hidden_excess = isHidden
        },
        SET_UPGRADE_QUOTE(state, inputValue) {
            for (const [key, value] of Object.entries(inputValue)) {
              window.Vue.set(state.upgradeQuote, key, value)
            }
        },
        RESET_UPGRADE_QUOTE(state) {
            state.upgradeQuote = {}
        },
        SET_BUSINESS_ACCOUNT(state, business_account) {
            state.business_account = business_account
        },
        SET_BUSINESS_ADDRESSES(state, business_addresses) {
            state.business_addresses = business_addresses
        },
        UPDATE_VEHICLE_DETAILS(state, { key, vrm, make, model, year, otherVehicleError }) {
            const vehicle = state.vehicles[key];
            if (vehicle) {
                if (vrm) Vue.set(vehicle, 'vrm', vrm);
                if (make) Vue.set(vehicle, 'make', make);
                if (model) Vue.set(vehicle, 'model', model);
                if (year) Vue.set(vehicle, 'year', year);
                if (otherVehicleError !== undefined) Vue.set(vehicle, 'otherVehicleError', otherVehicleError);
            }
        },
        VEHICLES_REMOVED(state, vehicle_removed) {
            state.vehicles_removed = vehicle_removed
        },
    },
    strict: debug,
    plugins: [vuexLocal.plugin]
})
